import Home from '@/pages/home'
import Detail from "@/pages/detail";
import {Navigate} from "react-router";
const routes = [
    {
        path: '/',
        element: <Home/>,
    },
    {
        path: '/detail',
        element: <Detail/>,
    },
    {
        path: '*',
        element: <Navigate to=""/>
    },
];
export default routes;
